export default {
  data: () => ({
    conClasePregrabada: false,
    precioClasePregrabada: 0,
    baseTotalSinClase: null,
  }),

  created() {
    this.cargarPrecioClasePregrabada()
  },

  methods: {
    cargarPrecioClasePregrabada() {
      this.$http.get('curso.virtual.precio').then((response) => {
        const data = response.data || response.body || {}
        this.precioClasePregrabada = Number(data.monto) || 0
        if (this.conClasePregrabada) this.sumarClasePregrabada()
      }).catch(() => {})
    },

    sumarClasePregrabada() {
      if (this.baseTotalSinClase == null) {
        this.baseTotalSinClase = Number(this.total_a_pagar) || 0
      }
      const extra = this.conClasePregrabada ? Number(this.precioClasePregrabada) || 0 : 0
      this.total_a_pagar = Number(this.baseTotalSinClase) + extra
    },

    fijarTotalBaseClase(total) {
      this.baseTotalSinClase = Number(total) || 0
      const extra = this.conClasePregrabada ? Number(this.precioClasePregrabada) || 0 : 0
      this.total_a_pagar = this.baseTotalSinClase + extra
    },

    guardarPendienteClase(response) {
      if (!this.conClasePregrabada) return
      const data = response && (response.data || response.body) ? (response.data || response.body) : {}
      const ingreso = data.ingreso || {}
      const idIngreso = ingreso.id || ingreso.id_ingreso || data.id_ingreso
      if (!idIngreso) return
      const alumno = this.alumno || {}
      const unidad = Number(alumno.unidad_negocio || alumno.escuela || 1)
      this.$http.post('curso.virtual.pendiente', {
        id_ingreso: idIngreso,
        matricula: alumno.matricula,
        nombre: alumno.alumno || alumno.nombre || '',
        email: alumno.email || '',
        monto: this.precioClasePregrabada,
        marca: unidad === 2 ? 'fast' : 'inbi',
      }).catch(() => {})
    },
  },
}
